// export { default as Navbar } from './Navbar.vue';
// export { default as Sidebar1 } from './Sidebar/index.vue';
// export { default as AppMain } from './AppMain.vue';

// 检查文件路径是否正确


export { default as Navbar } from './Navbar.vue';
export { default as Sidebar } from './Sidebar/index.vue';
export { default as AppMain } from './AppMain.vue';
